/**
 * 全局
 */
export default {

}
